module.exports = __webpack_public_path__ + "img/authorlevel1.d5b91ca2.png";